// sagas.js
import { takeLatest, put, call } from 'redux-saga/effects';
import { fetchUserRoleSuccess, fetchUserRoleError, loginSuccess, loginError, loginWithOtpSuccess, loginWithOtpError, forgotPasswordSuccess, forgotPasswordError, resetPasswordSuccess, resetPasswordError, getUserProfileDetailsSuccess, getUserProfileDetailsError } from './action';
import { LoginOtp, checkLowWalletBalance, consumeResetPassword, getAllBrand, getAllCategory, getAllCompanys, getMyuserHasRole, getProfile, logoutUser, remember, requestResetPassword, userLogin } from '../../api';
import { FETCH_USER_ROLE, FORGOT_PASSWORD, GET_PROFILE, LOGIN, LOGIN_WITH_OTP, RESET_PASSWORD } from '../actionTypes';
import { getFromLocalStorage, setInLocalStorage } from '../../hooks/useLocalStorage';
import { makeid } from '../../services/data-encription';
import { getAllBrandsData, getAllBrandsDataSuccess, getAllCompaniesData, getAllCompaniesDataSuccess } from '../affiliations/action';
import { getAllCategoryRedux, getAllCategoryReduxSuccess, getCategoryForAll } from '../sales/action';
import moment from 'moment';
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import SweetAlert from 'sweetalert2';
// import { COMPANY_MODULE } from '../../constant';


function* fetchUserRoleSaga(action) {
  try {
    const { navigate } = action.payload;
    const user = JSON.parse(localStorage.getItem("user"))
    if (!user) {
      logoutUser(navigate)
    }
    const { data } = yield getMyuserHasRole(user.user_id);
    if (!data) {
      logoutUser(navigate)
    }
    const result = []
    data.result.forEach((ele) => {
      if (ele.is_active === true) {
        result.push(ele.role)
      }
    })
    if (result.length === 1) {
      localStorage.setItem("ROLE", JSON.stringify({ "name": result[0].name.toUpperCase(), "key": result[0].alias.toUpperCase(), "alias": result[0].alias, role_id: result[0].role_id, role_order: result[0].role_order }));
      
      navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
    }
    else {
    }
    yield put(fetchUserRoleSuccess(result));
  } catch (error) {
    yield put(fetchUserRoleError(error));
  }
}

function* loginSaga(action) {
  const { userDetails, navigate, remember, toast, setLoading, showToast, setShowToast } = action.payload;
  const { email } = userDetails;

  try {
    const data = yield userLogin(userDetails);
    if (data) {
      yield put(loginSuccess(data.data.msg));
      setInLocalStorage("isRememberMe", remember ? true : false)
      navigate('/otp', { state: { email: email, remember, lastThreePhoneDigits: data.data?.msg } });
    }
  } catch (error) {

    // console.log(err.response, "line 64")
    if (error.response.data.code == 413) {
      const temp = {
        email: error.response.data.result?.userEmail,
        phone_no: error.response.data.result?.phoneNo,
        result: error.response.data.result
      }
      navigate('/user/first-login', { state: temp });
    } 
    else if (error.response.data.code == 400 && error.response.data.error === "PASSWORD EXPIRED") {
    // Show toast
    if (!showToast) {
      setShowToast(true);
      toast.error("Your password has expired. Please update it.");
      setTimeout(() => {
        setShowToast(false);
      }, 6000);
    }
  
    // Navigate to login with modal
    navigate("/login", {
      state: {
        showPasswordExpiredModal: true,
        expiredUserData: {
          email: userDetails.email,
          password: userDetails.password
        }
      }
    });
  } else if (error.response.data.code == 500 && error.response.data.error === "Password policy update failed") {
    // Show toast
    if (!showToast) {
      setShowToast(true);
      toast.error("Password update failed. Please ensure your password meets the required policy.");
      setTimeout(() => {
        setShowToast(false);
      }, 6000);
    }
  
    // Navigate to login with modal
    navigate("/login", {
      state: {
        showPasswordExpiredModal: true,
        expiredUserData: {
          email: userDetails.email,
          password: userDetails.password
        }
      }
    });

  }
    else {
      // toast.error(error.response.data.error);
      setTimeout(() => {
        setLoading(false)
      }, [2000])
      if (!showToast) {
        setShowToast(true);
        // const errorMsg = error.response.data.error;
        // // const errorMsg = "Host '123.123.12.10' is blocked because of many connection errors; unblock with 'mysqladmin flush-hosts'";
        // const blockedMsgPattern = /Host '\d+\.\d+\.\d+\.\d+' is blocked because of many connection errors; unblock with 'mysqladmin flush-hosts'/;
        // let formattedError = errorMsg;
        // if (blockedMsgPattern.test(errorMsg)) {
        //     formattedError = errorMsg.replace(/Host '\d+\.\d+\.\d+\.\d+' is/, "Host is");
        // }
        // toast.error(formattedError);
        const errorCode = error?.response?.data?.code;
        if (errorCode == 500){
          toast.error('Something went wrong');
        }else{
          toast.error(error?.response?.data?.error);
        }
        // toast.error(error?.response?.data?.msg);
        setTimeout(() => {
          setShowToast(false);
        }, 6000);
      }
      yield put(loginError(error));
    }


  }
}

function* loginWithOtpSaga(action) {
  const { userOtpDetails, location, navigate, toast, setLoading, dispatch } = action.payload;
  try {
    // const {email, password} = userDetails
    const { email, otp } = userOtpDetails
    const { data } = yield LoginOtp({ email, otp });
    if (data) {
      setInLocalStorage("user", JSON.stringify(data.result.userData));
      setInLocalStorage("token", data.result.AuthorisationToken);
      setInLocalStorage("Name", data.result.userData.name);
      if (getFromLocalStorage("isRememberMe") == true || getFromLocalStorage("isRememberMe") == "true") {
        let browserId = makeid(26);
        setInLocalStorage("browserId", browserId)
        remember({ browser_id: browserId })
      }

      const res = yield getMyuserHasRole(data.result.userData.user_id);
      const result = []
      // console.log(data.result)
      res.data.result.forEach((ele) => {
        if (ele.is_active === true) {
          result.push(ele.role)
        }
      })
      yield put(loginWithOtpSuccess(data.result.userData));
      dispatch(getAllCompaniesData())
      // const getAllCategoryData = yield getAllCategory();
      // if (getAllCategoryData) {
      //   yield put(getAllCategoryReduxSuccess(getAllCategoryData.data?.result?.map((ele) => {
      //     return {
      //       sales_category_id: ele?.sales_category_id,
      //       name: ele?.name,
      //     }
      //   })));
      // }
      dispatch(getCategoryForAll())
      dispatch(getAllBrandsData())
      // const getAllBrandData = yield getAllBrand();
      // if (getAllBrandData) {
      //   yield put(getAllBrandsDataSuccess(getAllBrandData.data?.result?.brandDetails?.map((ele) => {
      //     return {
      //       brand_id: ele?.brand_id,
      //       name: ele?.name,
      //     }
      //   })));
      // }


      if (result.length === 1) {
        // setInLocalStorage("ROLE", JSON.stringify({ "name": result[0].name.toUpperCase(), "key": result[0].name.toUpperCase() }));
        setInLocalStorage("ROLE", JSON.stringify({ "name": result[0].name.toUpperCase(), "key": result[0].alias.toUpperCase(), "alias": result[0].alias, role_id: result[0].role_id, role_order: result[0].role_order }));

        if (navigate) {
          const TodayDate = moment(new Date()).format("YYYY-MM-DD");
          const lastLoginDetails = moment(getFromLocalStorage('user')?.lastLoginDetails?.created_at);
          const userLastLoginDetails = lastLoginDetails.format("YYYY-MM-DD");
          const wallet_closure_status = getFromLocalStorage('user')?.partnerInfo?.wallet_closure_status;
          const is_kyc_active = getFromLocalStorage('user')?.partnerInfo?.is_kyc_active || getFromLocalStorage('user')?.consolidatorInfo?.is_kyc_active;
          const re_kyc = getFromLocalStorage('user')?.partnerInfo?.re_kyc || getFromLocalStorage('user')?.consolidatorInfo?.re_kyc;
          const is_gst_registered = getFromLocalStorage('user')?.partnerInfo?.is_gst_registered || getFromLocalStorage('user')?.consolidatorInfo?.is_gst_registered;
          const consolidator_is_kyc_active = getFromLocalStorage('user')?.consolidatorInfo?.is_kyc_active;
          const is_KYC = getFromLocalStorage('user')?.partnerInfo?.is_kyc;
          const dealer_first_login = getFromLocalStorage('user')?.partnerInfo?.dealer_first_login;

          // const salesCertificateURL = `${process.env.PUBLIC_URL}/sales/policies/certificate`;
          const salesCertificateURL = `${process.env.PUBLIC_URL}/sales/policies/create-new/1?isLogin=true`;
          const cashifyPolicyURL = `${process.env.PUBLIC_URL}/sales/policies/create/1`;
          const defaultDashboardURL = `${process.env.PUBLIC_URL}/users/users`;
          const partnership_id = getFromLocalStorage('user')?.partnerInfo?.partnership_id;
          const COMPANY_MODULE = getFromLocalStorage("user")?.companyInfo?.module_id;
          const MODULE_ID = getFromLocalStorage("user")?.moduleMapInfo?.module_id;

          if ((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER" || getFromLocalStorage('ROLE')?.key == "CONSOLIDATOR") ) {
            // if((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") && !dealer_first_login){
            // navigate(defaultDashboardURL);
            // navigate(salesCertificateURL);
             if (MODULE_ID && MODULE_ID == 3) {
              navigate(`${process.env.PUBLIC_URL}/sales/policies/nyom`);
            }

            if (is_gst_registered === true && re_kyc === true) {
              // navigateUrl = `${process.env.PUBLIC_URL}/documents/kyc`;
              const showReKycPopup = () => {
                SweetAlert.fire({
                  title: "Re-KYC Required",
                  html: `
              <div style="text-align: left; font-family: 'Poppins', sans-serif;">
                <div style="margin-bottom: 20px;">
                  <h5 style="color: #dc3545; margin-bottom: 15px;">
                    <i class="fa fa-exclamation-triangle" style="margin-right: 8px;"></i>
                    GST Status Verification Failed
                  </h5>

                  <div style="padding: 12px; background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px;">
                    <p style="margin: 0; color: #856404; font-size: 14px; line-height: 1.6;">
                      Your GST registration status is found as
                      <strong>Cancelled / Suspended / Inactive</strong>
                      during monthly verification.
                    </p>

                    <p style="margin: 10px 0 0 0; color: #856404; font-size: 14px; line-height: 1.6;">
                      Please complete <strong>Re-KYC</strong> and submit valid GST
                      registration documents with status as
                      <strong>Active</strong> on the GST Portal.
                    </p>

                        <p style="margin: 10px 0 0 0; color: #dc3545; font-size: 14px; font-weight: 600;">
                          B2B invoicing has been suspended until approval.
                        </p>
                      </div>
                    </div>
                  </div>
                `,
                  icon: "warning",
                  confirmButtonText: "Proceed to Re-KYC",
                  confirmButtonColor: "#00239c",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                });
              };
              if (is_gst_registered === true && re_kyc === true) {
                // alert(
                //   "Your GST registration status is found as Cancelled/Suspended/Inactive during monthly verification. Please complete Re-KYC and submit valid GST registration documents with status as active at GST Portal. B2B invoicing has been suspended until approval."
                // );
                showReKycPopup();
              }
              navigate(`${process.env.PUBLIC_URL}/documents/kyc`);
            } else {
              console.log(COMPANY_MODULE, 'COMPANY_MODULE11111')
              if (getFromLocalStorage('ROLE')?.key == "CONSOLIDATOR") {
                navigate(`${process.env.PUBLIC_URL}/sales/policies/certificate`);
              }
              // navigate(salesCertificateURL);
              
              else if (MODULE_ID && MODULE_ID == 3) {
                navigate(`${process.env.PUBLIC_URL}/sales/policies/nyom`);
              }

              else if (COMPANY_MODULE && COMPANY_MODULE == 2) {
                // console.log("11............")
                navigate(`${process.env.PUBLIC_URL}/sales/policies`);
              } else {
                // console.log("22............")
                navigate(salesCertificateURL);
              }
            }
          } else if ((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") && (userLastLoginDetails !== TodayDate)) {
            if (wallet_closure_status == "ACTIVE" && is_kyc_active == true && is_KYC == true) {
              checkLowWalletBalance(partnership_id)
                .then((res) => {
                }).catch((err) => {
                  console.log("Something went wrong")
                });
              navigate(defaultDashboardURL);
            }
          } else if (((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER")) && (userLastLoginDetails === TodayDate)) {
            // navigate(`${process.env.PUBLIC_URL}/sales/policies/create/1`);
            if (wallet_closure_status == "ACTIVE" && is_kyc_active == true && is_KYC == true) {
              // navigate(`${process.env.PUBLIC_URL}/sales/policies/certificate`);
              // navigate(salesCertificateURL);
              if (COMPANY_MODULE && COMPANY_MODULE == 2) {
                // console.log("3...........")
                navigate(`${process.env.PUBLIC_URL}/sales/policies`);
              } else {
                // console.log("4...........")
                navigate(`${process.env.PUBLIC_URL}/sales/policies/certificate`);
              }
            } else {
              navigate(defaultDashboardURL);
            }
          } else if ((getFromLocalStorage('ROLE')?.key == "DEALER_SALES_PERSON") || getFromLocalStorage('ROLE').key == 'RO' || (getFromLocalStorage('ROLE')?.key == "FINANCE") || (getFromLocalStorage('ROLE')?.key == "HO")) {
            // navigate(`${process.env.PUBLIC_URL}/sales/policies/certificate`);
            if (COMPANY_MODULE && COMPANY_MODULE == 2) {
              // console.log("3...........")
              navigate(`${process.env.PUBLIC_URL}/sales/policies`);
            } else {
              // console.log("4...........")
              navigate(`${process.env.PUBLIC_URL}/sales/policies/certificate`);
            }
          }
          else if(getFromLocalStorage('ROLE')?.key == "CONSOLIDATOR"){
              // if (MODULE_ID && MODULE_ID == 3) {
              //   navigate(`${process.env.PUBLIC_URL}/sales/policies/nyom`);
              // }

                if (consolidator_is_kyc_active != true) {
                    navigate(`${process.env.PUBLIC_URL}/documents/kyc`);
              }
              else navigate(`${process.env.PUBLIC_URL}/sales/policies/certificate`);
          } 
          else {
            navigate(defaultDashboardURL);
          }
        }
        // window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`;
      }
      else {
        if (navigate) {
          navigate(`${process.env.PUBLIC_URL}/user/role`);
        }
        // window.location.href = `${process.env.PUBLIC_URL}/user/role`;
      }
    }

  } catch (error) {
    toast.error(error.response.data.error);
    if (setLoading) {
      setLoading(false);
    }
    yield put(loginWithOtpError(error));
  }
}

function* forgotPasswordSaga(action) {
  const { email, navigate, toast } = action.payload;
  try {

    yield requestResetPassword({ email: email }).then((res) => {
      toast.success(res.data.msg);
      navigate('/mail_sent', { state: { email: email } });
      put(forgotPasswordSuccess(res.data.msg));
    }).catch((error) => {
      toast.error(error.response?.data?.error);
      put(forgotPasswordError(error.response?.data?.error));
    });

  } catch (error) {
    toast.error(error.response.data.message);
    yield put(forgotPasswordError(error?.message));
  }
}

function* resetPasswordSaga(action) {
  try {
    const { newPassword, token, navigate, toast } = action.payload;

    const resp = yield consumeResetPassword({ newPassword: newPassword, token: token })
    if (resp) {
      const { data } = resp
      if (data) {
        toast.success(data.message);
        yield put(resetPasswordSuccess(data.message));
        yield call(() =>
          Swal.fire({
            icon: 'success',
            title: 'Password Reset',
            text: 'Your password has been successfully reset.',
          })
        );
        navigate('/login');
      }
    } else {
      toast.error('something went wrong');
    }
  } catch (error) {
    if (error.response && error.response.status === 400 && error.response.data && error.response.data.error) {
      toast.error(error.response.data.error);
    } else {
      toast.error('An error occurred');
    }
    yield put(resetPasswordError(error.message));
  }
}


function* getProfileSaga() {
  try {
    const resp = yield getProfile();
    if (resp) {
      yield put(getUserProfileDetailsSuccess(resp?.data?.result));
    }
  } catch (error) {
    yield put(getUserProfileDetailsError(error?.response?.data?.message));
  }
}

export function* watchLoginData() {
  yield takeLatest(FETCH_USER_ROLE, fetchUserRoleSaga);
  yield takeLatest(LOGIN, loginSaga);
  yield takeLatest(LOGIN_WITH_OTP, loginWithOtpSaga);
  yield takeLatest(FORGOT_PASSWORD, forgotPasswordSaga);
  yield takeLatest(RESET_PASSWORD, resetPasswordSaga);
  yield takeLatest(GET_PROFILE, getProfileSaga);
}

